var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _vm.aviso == "S"
          ? _c("div", { staticClass: "card" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1)
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("input", {
                  attrs: { type: "checkbox", value: "false", id: "devolucao" },
                  on: { change: _vm.setDevolucao }
                }),
                _vm._v(" "),
                _c("label", { staticClass: "form-check-label" }, [
                  _vm._v(" Filtrar por devoluções")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12 mt-4" }, [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    value: "false",
                    id: "tipo-titulo"
                  },
                  on: { change: _vm.setTipoTitulo }
                }),
                _vm._v(" "),
                _c("label", { staticClass: "form-check-label" }, [
                  _vm._v(
                    "\n                Filtrar por boletos emitidos para o distribuidor (boletos não\n                pagos pela revendedora e não devolvidos)"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col mt-4" }, [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    value: "false",
                    id: "data-pagamento"
                  },
                  on: { change: _vm.setDtPagamento }
                }),
                _vm._v(" "),
                _c("label", { staticClass: "form-check-label" }, [
                  _vm._v(
                    "\n                Filtrar por data de pagamento da comissão"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group row mt-4" }, [
              _c("label", { staticClass: "col-sm-2 col-form-label" }, [
                _vm._v("Data de emissão")
              ]),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "comissoes", value: "1" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data_emissao,
                        expression: "data_emissao"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      required: "",
                      id: "data_emissao",
                      disabled: _vm.filtraPagamento
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.data_emissao = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.emissoes, function(item, i) {
                    return _c(
                      "option",
                      { key: i, domProps: { value: item.dtemissao_titulo } },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.formatData(item.dtemissao_titulo)) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "submit", disabled: _vm.filtraPagamento },
                    on: { click: _vm.getComissoes }
                  },
                  [_vm._v("\n                Buscar\n              ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.Limpar }
                  },
                  [_vm._v("\n                Limpar\n              ")]
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(3)
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _vm.linhas.length > 0
          ? _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header bg-primary text-white" }, [
                _vm._v("Resumo")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "panel-body" }, [
                _c("div", { staticClass: "table" }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table-hover table-striped table-bordered table-sm",
                      attrs: { width: "100%" }
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.showResumo, function(item, i) {
                          return _c("tr", { key: i }, [
                            _c("td", [_vm._v(_vm._s(item.situacao))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(item.total ? item.total : 0.0))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    item.valor_total
                                      ? item.valor_total
                                          .toString()
                                          .replace(".", ",")
                                      : 0.0
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    item.total_comissao
                                      ? item.total_comissao
                                          .toString()
                                          .replace(".", ",")
                                      : 0.0
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(item.percentual ? item.percentual : 0) +
                                  " %"
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ]
                  )
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("br")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _vm.detalhes.length > 0
          ? _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header bg-primary text-white" }, [
                _vm._v("\n          Detalhes "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.filtraPagamento ? " de comições PAGAS " : "")
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("small", [
                  _vm._v("Você filtrou por apenas comissões pagas...")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "table",
                  {
                    staticClass:
                      "table-hover table-striped table-bordered table-sm",
                    attrs: { width: "100%" }
                  },
                  [
                    _c("tr", [
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.revendedora,
                              expression: "revendedora"
                            }
                          ],
                          staticClass: "form-control",
                          domProps: { value: _vm.revendedora },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.revendedora = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pdv_nome,
                              expression: "pdv_nome"
                            }
                          ],
                          staticClass: "form-control",
                          domProps: { value: _vm.pdv_nome },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.pdv_nome = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filtraEmissao,
                                expression: "filtraEmissao"
                              }
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.filtraEmissao = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Sem filtro")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.getDataEmissao, function(item, i) {
                              return _c(
                                "option",
                                {
                                  key: i,
                                  domProps: { value: _vm.formatData(item) }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.formatData(item)) +
                                      "\n                  "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("td"),
                      _vm._v(" "),
                      _c("td"),
                      _vm._v(" "),
                      _c("td"),
                      _vm._v(" "),
                      _c("td", [
                        _c("b", [_vm._v("R$ " + _vm._s(_vm.swowTotalTitulo))])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("b", [_vm._v("R$ " + _vm._s(_vm.swowTotalcomissao))])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filtraPgto,
                                expression: "filtraPgto"
                              }
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.filtraPgto = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Sem filtro")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.getDataPgto, function(item, i) {
                              return _c(
                                "option",
                                {
                                  key: i,
                                  domProps: { value: _vm.formatData(item) }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.formatData(item)) +
                                      "\n                  "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.situacao,
                                expression: "situacao"
                              }
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.situacao = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Sem Filtro")
                            ]),
                            _vm._v(" "),
                            _c("option", [_vm._v("Comissão Paga")]),
                            _vm._v(" "),
                            _c("option", [_vm._v("Devolvido")]),
                            _vm._v(" "),
                            _c("option", [_vm._v("Pago")]),
                            _vm._v(" "),
                            _c("option", [_vm._v("Aberto")]),
                            _vm._v(" "),
                            _c("option", [_vm._v("Em Devolução")]),
                            _vm._v(" "),
                            _c("option", [_vm._v("Descontado do Distrib.")])
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.showDetalhes, function(item, i) {
                        return _c("tr", { key: i }, [
                          _c("td", [_vm._v(_vm._s(item.nome_revendedora))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.pdv_nome))]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(item.data_emissao))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(item.data_vencimento))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(item.data_pagamento))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "/boleto/generate/" + item.boleto_id,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.titulo) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v("R$ " + _vm._s(item.valor_titulo))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(item.comissao))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(item.pagamento))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(item.status))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            item.historico == "-"
                              ? _c("span", [_vm._v(" - ")])
                              : _c("span", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showHist(item)
                                        }
                                      }
                                    },
                                    [_vm._v("Ver detalhes")]
                                  )
                                ])
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", [
                        _c("td"),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [_vm._v("R$ " + _vm._s(_vm.swowTotalTitulo))])
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [
                            _vm._v("R$ " + _vm._s(_vm.swowTotalcomissao))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td")
                      ])
                    ])
                  ]
                )
              ])
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal fade", attrs: { id: "my-modal" } }, [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("p", { domProps: { innerHTML: _vm._s(_vm.hist) } })
            ]),
            _vm._v(" "),
            _vm._m(7)
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-primary text-white" }, [
      _c("b", [_vm._v("Atenção!!!!!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _vm._v(
            "\n              REPASSE DE COMISSÃO BLOQUEADA. FAVOR ENTRAR EM CONTATO COM O\n              C.D.\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-primary text-white" }, [
      _c("b", [_vm._v("Comissões")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("span", { staticClass: "badge badge-warning" }, [
          _vm._v(
            "Obs.: As comissões serão repassadas para as contas bancárias\n                nos dias 05 e 20 de cada mês"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Situação")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Comissão")]),
        _vm._v(" "),
        _c("th", [_vm._v("Percentual")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Revendedora")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ponto de apoio")]),
        _vm._v(" "),
        _c("th", [_vm._v("Data Emissão")]),
        _vm._v(" "),
        _c("th", [_vm._v("Data de Vencimento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Data Pagamento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Título")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "10%" } }, [_vm._v("Valor")]),
        _vm._v(" "),
        _c("th", [_vm._v("Comissao")]),
        _vm._v(" "),
        _c("th", [_vm._v("Data Transf. Comissão")]),
        _vm._v(" "),
        _c("th", [_vm._v("Situação")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "10%" } }, [_vm._v("Historico")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Histórico")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("\n            fechar\n          ")]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f52656c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f52656c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/relatorio/TabelaComissoes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4f52656c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/relatorio/TabelaComissoes.vue
// module chunks = 2